//export const baseUrl = "http://10.40.55.28:6004"
// export const baseUrl = "https://api-bhtt.mobifone5.vn/api-bhtt"
// export const baseUrl = "https://dulichbanchieng.com.vn"
// export const baseUrl = "https://dulichnamcuong.com.vn"
 export const baseUrl = "https://cathai.mobifone5.vn/"
export default {
    baseUrl
}
